import { render, staticRenderFns } from "./StopRecordList.vue?vue&type=template&id=3ca90050&scoped=true"
import script from "./StopRecordList.vue?vue&type=script&lang=js"
export * from "./StopRecordList.vue?vue&type=script&lang=js"
import style0 from "./StopRecordList.vue?vue&type=style&index=0&id=3ca90050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca90050",
  null
  
)

export default component.exports